import { PropsWithChildren } from "react";

import searchImage from "#shared/images/search.png";
import { Group } from "#shared/view/components/Group";
import { Image } from "#shared/view/components/Image";
import { SimpleLoader } from "#shared/view/components/Loader";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

export const SearchingStatusCheck = ({
  isSearching,
  children,
}: { isSearching: boolean } & PropsWithChildren) => {
  if (isSearching) {
    return (
      <Stack align={"center"} justify={"center"} mt={"sm"}>
        <Image src={searchImage} w={150} h={150} />
        <Group>
          <SimpleLoader variant="dots" size="lg" />

          <Text inline fz="md">
            Recherche en cours...
          </Text>
        </Group>
      </Stack>
    );
  }

  return children;
};
